<template>
  <!-- !! TODO: SuiteListIcon 已經要被棄用，請改用新的組件 -->
  <SuiteListIcon :suite-data="suiteData" />
</template>

<script setup lang="ts">
  import EN_AMERICAS_JSON from '@/assets/data/home/en-americas/section-1-2.json';
  import EN_ASIA_PACIFIC_JSON from '@/assets/data/home/en-asia-pacific/section-1-2.json';
  import EN_EMEA_JSON from '@/assets/data/home/en-emea/section-1-2.json';
  import EN_INT_JSON from '@/assets/data/home/en-int/section-1-2.json';
  import EN_JP_JSON from '@/assets/data/home/en-jp/section-1-2.json';
  import EN_KR_JSON from '@/assets/data/home/en-kr/section-1-2.json';
  import EN_TW_JSON from '@/assets/data/home/en-tw/section-1-2.json';
  import JA_JP_JSON from '@/assets/data/home/ja-jp/section-1-2.json';
  import ZH_TW_JSON from '@/assets/data/home/zh-tw/section-1-2.json';
  import type { IListIcon } from '@/components/Shared/Suite/ListIcon/index.vue';

  interface IListIconItem {
    name: string;
    description: string;
    thumbnail: string;
  }

  interface IListIconData {
    title: string;
    items: IListIconItem[];
  }

  const { locale } = useI18n();
  const { provideImgUrl } = useHomeData();

  const contextData = computed((): IListIconData => {
    switch (locale.value) {
      case EnumLocale.EN_INT:
        return EN_INT_JSON;
      case EnumLocale.EN_AMERICAS:
        return EN_AMERICAS_JSON;
      case EnumLocale.EN_JP:
        return EN_JP_JSON;
      case EnumLocale.EN_TW:
        return EN_TW_JSON;
      case EnumLocale.EN_KR:
        return EN_KR_JSON;
      case EnumLocale.EN_ASIA_PACIFIC:
        return EN_ASIA_PACIFIC_JSON;
      case EnumLocale.EN_EMEA:
        return EN_EMEA_JSON;
      case EnumLocale.ZH_TW:
        return ZH_TW_JSON;
      case EnumLocale.JA_JP:
        return JA_JP_JSON;
      default:
        return EN_INT_JSON;
    }
  });

  const suiteData = computed(
    (): IListIcon => ({
      component: 'list-icon',
      meta: {},
      data: {
        title: contextData.value.title,
        numberOfLine: 4,
        items: contextData.value.items.map((item: IListIconItem) => ({
          name: item.name,
          description: item.description,
          thumbnail: provideImgUrl(item.thumbnail),
        })),
      },
    })
  );

  export type { IListIconData, IListIconItem };
</script>
